import { render, staticRenderFns } from "./WidgetOverlay.vue?vue&type=template&id=6818c375&scoped=true&"
import script from "./WidgetOverlay.vue?vue&type=script&lang=js&"
export * from "./WidgetOverlay.vue?vue&type=script&lang=js&"
import style0 from "./WidgetOverlay.vue?vue&type=style&index=0&id=6818c375&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6818c375",
  null
  
)

export default component.exports